import { Query } from '@tilework/opus';
import { connect } from 'react-redux';

import {MenuContainerMapDispatchProps, MenuContainerProps} from 'Component/Menu/Menu.type';
import {
    mapStateToProps as sourceMapStateToProps,
    MenuContainer as SourceMenuContainer,
} from 'SourceComponent/Menu/Menu.container';
import {NetworkError} from 'Type/Common.type';
import {noopFn} from 'Util/Common';
import {getFirstLevelWithChild} from 'Util/DesktopMenu';
import {makeCancelable} from 'Util/Promise';
import {prepareQuery} from 'Util/Query';
import {executePost, listenForBroadCast} from 'Util/Request/Request';
import {RootState} from 'Util/Store/Store.type';

/** @namespace Steinkrueger/Component/Menu/Container/mapStateToProps */
export const mapStateToProps = (state: RootState) => ({
    ...sourceMapStateToProps(state),
    isSignedIn: state.MyAccountReducer.isSignedIn,
    activeOverlay: state.OverlayReducer.activeOverlay,
});

/** @namespace Steinkrueger/Component/Menu/Container/mapDispatchToProps */
export const mapDispatchToProps = (): MenuContainerMapDispatchProps => ({});

/** @namespace Steinkrueger/Component/Menu/Container */
export class MenuContainer extends SourceMenuContainer {
    componentDidUpdate(prevProps: Readonly<MenuContainerProps>) {
        const { isSignedIn, activeOverlay } = this.props;
        const { activeOverlay: prevActiveOverlay } = prevProps;

        if (isSignedIn !== prevProps.isSignedIn) {
            this._getMenu();
        }

        if (activeOverlay !== prevActiveOverlay) {
            this.closeMenu();
        }
    }

    closeMenu(): void {
        const { device } = this.props;
        const { menu } = this.state;

        if (device.isMobile) {
            return;
        }

        this.setState({ activeMenuItemsStack: getFirstLevelWithChild(menu) });
    }

    fetchData<T = unknown, E = NetworkError | NetworkError[]>(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        rawQueries: Query<string, any, boolean>[],
        onSuccess: (x: T) => void = noopFn,
        onError: (x: E) => void = noopFn,
    ): void {
        const preparedQuery = prepareQuery(rawQueries);

        this.promise = makeCancelable(
            executePost(preparedQuery),
        );

        this.promise.promise.then(
            /** @namespace Steinkrueger/Component/Menu/Container/MenuContainer/fetchData/then */
            (response) => {
                onSuccess(response as T);
            },
            /** @namespace Steinkrueger/Component/Menu/Container/MenuContainer/fetchData/then/onError/catch */
            (err) => onError(err),
        );

        if (this.isShouldListenForBroadcast) {
            listenForBroadCast<T>(this.dataModelName).then(
                /** @namespace Util/Request/DataContainer/DataContainer/fetchData/listenForBroadCast/then/onSuccess */
                onSuccess,
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
